module.exports = __webpack_public_path__ + "static/media/Condiciones-Generales-Cobertura-Yacht-Standard.fbdbd033.pdf";